"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.list.title': '价格套餐',
};
